/// <reference lib="dom" />

import { useEffect } from 'react';
import States from '../states';
import { useMMKVNumber } from 'react-native-mmkv';

const detectKey = [
  'Enter',
  'Space',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Escape',
];

export default function useMouseControl() {
  const [mouseMode] = useMMKVNumber('mouseMode');
  useEffect(() => {
    const mode = mouseMode ?? 0;
    if (mode !== 0) {
      States.settingsState.mouse = mode === 1;
      return;
    }

    const keyPress = (e: KeyboardEvent) => {
      if (detectKey.includes(e.code)) {
        States.settingsState.mouse = false;
        document.addEventListener('pointermove', pointerMove, { once: true });
        document.removeEventListener('keydown', keyPress);
      }
    };
    const pointerMove = () => {
      States.settingsState.mouse = true;
      document.addEventListener('keydown', keyPress);
    };
    document.addEventListener('keydown', keyPress);
    return () => {
      document.removeEventListener('pointermove', pointerMove);
      document.removeEventListener('keydown', keyPress);
    };
  }, [mouseMode]);
}
